import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const CheckOutlineIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Check Outline`} {...props}>
    <Path
      fill="currentColor"
      d="M12.0303 6.03033C12.3232 5.73744 12.3232 5.26256 12.0303 4.96967C11.7374 4.67678 11.2626 4.67678 10.9697 4.96967L6.5 9.43934L5.03033 7.96967C4.73744 7.67678 4.26256 7.67678 3.96967 7.96967C3.67678 8.26256 3.67678 8.73744 3.96967 9.03033L5.96967 11.0303C6.26256 11.3232 6.73744 11.3232 7.03033 11.0303L12.0303 6.03033Z"
    />
    <Path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8Z"
    />
  </Icon>
);
